import React from 'react';

import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';

import i18n from 'i18n';

import {
  memberListUrl,
  tenantDashboardUrl,
  paymentListUrl,
  settingsUrl,
  userTenantPayeeListUrl,
} from 'constants/url';

import { APITenant } from 'types/api';
import { MenuType } from 'types/app';

export const BriksioTenantMenu = (
  tenant?: APITenant,
): MenuType[] => {
  const orgId = tenant?.id;
  const url = (real?: () => string) => (real && orgId ? real : () => '#');

  return [
{
      items: [
        {
          id: 'menu-dashboard',
          url: url(orgId ? () => tenantDashboardUrl(orgId) : undefined),
          text: 'Dashboard',
          icon: <DashboardOutlinedIcon fontSize="small" />,
        },
      ],
    },

{
      subHeader: 'Inventory Control',
      items: [
        {
          id: 'menu-item-list',
          url: () => '#',
          text: 'Item List',
          icon: <ListAltOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-source-of-goods',
          url: () => '#',
          text: 'Source Of Goods',
          icon: <Inventory2OutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-documents',
          url: () => '#',
          text: 'Documents',
          icon: <DescriptionOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-catalog',
          url: () => '#',
          text: 'Catalog',
          icon: <CategoryOutlinedIcon fontSize="small" />,
        },
      ],
    },

{
      subHeader: 'Orders & Fulfillment',
      items: [
        {
          id: 'menu-orders',
          url: url(orgId ? () => paymentListUrl(orgId) : undefined),
          text: 'Orders',
          icon: <ShoppingCartOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-picker',
          url: () => '#',
          text: 'Picker',
          icon: <TouchAppOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-refunds',
          url: () => '#',
          text: 'Refunds & Returns',
          icon: <AssignmentReturnOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-customers',
          url: url(
            orgId ? () => userTenantPayeeListUrl(orgId) : undefined,
          ),
          text: 'Customers',
          icon: <GroupOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-insights',
          url: () => '#',
          text: 'Insights',
          icon: <InsightsOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-members',
          url: url(orgId ? () => memberListUrl(orgId) : undefined),
          text: 'Members',
          icon: <ManageAccountsOutlinedIcon fontSize="small" />,
        },
      ],
    },

{
      subHeader: 'Settings',
      items: [
        {
          id: 'menu-marketplace-pricing',
          url: () => '#',
          text: 'Marketplace Pricing',
          icon: <SellOutlinedIcon fontSize="small" />,
        },
        {
          id: 'menu-settings',
          url: url(orgId ? () => settingsUrl(orgId) : undefined),
          text: i18n.t('menu.settings'),
          icon: <SettingsOutlinedIcon fontSize="small" />,
        },
      ],
    },
  ];
};

// Keep legacy exports so other imports don't break
export const TenantUserMenu = BriksioTenantMenu;
export const TenantAdminMenu = (
  _tenant: APITenant,
): MenuType[] => [];
